module.exports = __webpack_public_path__ + "static/media/Posterior.53eab054.png";